<template>
    <div :class="{'col-xl-12': mode == 'table', 'col-xl-6': mode == 'graph'}">
        <b-overlay
            :show="status === 'loading'"
        >
            <b-card
                no-body
            >
                <div class="card-header align-items-start">
                    <div class="card-group-title">
                        <b-card-title>
                            {{ $t('org.billing.Region Cost') }}
                        </b-card-title>

                    </div>
                    <b-card-actions-container
                        v-if="(thisMonthRegions && thisMonthRegions.length) || (lastMonthRegions && lastMonthRegions.length)"
                        class="card-actions-container"
                        @card:collapse="toggleMode"
                    />
                </div>
                <b-card-body>
                    <template
                        v-if="(thisMonthRegions && thisMonthRegions.length) || (lastMonthRegions && lastMonthRegions.length)"
                    >
                        <RegionCardChart
                            ref="container"
                            :svg="svg"
                            :thisMonthRegions="thisMonthRegions"
                            :lastMonthRegions="lastMonthRegions"
                            @resize:svg="handleResize"
                            @detail-layer="detailLayer"
                        >
                        </RegionCardChart>
                        <RegionCardTable
                            v-show="mode == 'table'"
                            :thisMonthRegions="thisMonthRegions"
                            :lastMonthRegions="lastMonthRegions"
                            @detail-layer="detailLayer"
                        ></RegionCardTable>
                    </template>
                    <template v-else>
                        <div class="d-flex justify-content-center align-items-center flex-column text-center">
                            <SVGEmptyIcon/>
                            <span>{{ $t('org.dashboard.No data') }}</span>
                        </div>
                    </template>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import BCardActionsContainer from '@/components/BCardActionsContainer'
import RegionCardChart from './RegionCardChart'
import RegionCardTable from './RegionCardTable'
import { computed, ref, getCurrentInstance, watch, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        BCardActionsContainer,
        RegionCardChart,
        RegionCardTable,
        SVGEmptyIcon
    },
    props: {
        expanded: {
            type: String,
            default: null
        },
        data: {
            type: Object,
            default: function () {
                return {
                    thisMonthRegions: [],
                    lastMonthRegions: []
                }
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { expanded, data } = toRefs(props)
        const store = vm.$store
        const status = computed(() => store.getters['$_summary/status'])
        const svg = ref({ width: 0, height: 300 })
        const mode = ref('graph')
        const thisMonthRegions = computed(() => data.value && data.value.thisMonthRegions)
        const lastMonthRegions = computed(() => data.value && data.value.lastMonthRegions)
        const detailLayer = (region) => {
            if (region.toLowerCase() !== 'etc') {
                context.emit('detail-layer', { region })
            }
        }
        const container = ref(null)
        const handleResize = () => {
            if (container.value) {
                svg.value.width = container.value.$el.clientWidth
                svg.value.height = Math.min(svg.value.width * 0.75, (mode.value === 'graph' ? 250 : 300))
            }
        }
        const emitExpanded = () => context.emit('expand-panel', mode.value === 'table' ? 'region' : null)
        const toggleMode = () => {
            mode.value = mode.value === 'graph' ? 'table' : 'graph'
            vm.$nextTick(() => {
                handleResize()
            })
            emitExpanded()
        }
        watch(expanded, (value) => {
            mode.value = value === 'region' ? 'table' : 'graph'
            vm.$nextTick(() => {
                handleResize()
            })
        })
        return {
            status,
            svg,
            mode,
            container,
            detailLayer,
            toggleMode,
            handleResize,
            thisMonthRegions,
            lastMonthRegions
        }
    }
}
</script>

<style>
#containerRegionChart text.shadow {
    text-shadow: #000 2px 2px 10px
}
#containerRegionChart tspan.shadow {
    text-shadow: #000 2px 2px 10px
}
</style>
